import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';

@Injectable()
export class CxcService {

  constructor(private http: HttpClient) { }

  cxcRegister(data) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/cxcpayment', { data: data }, { headers: headers });
  }

  anulateInnvoce(body) {
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/anulateProduction', body, { headers: headers });
  }

  cxcRegisterNote(data) {
    console.log("notas")
    const headers = new HttpHeaders()
      .set('Content-type', 'application/json')
      .append('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.post(Constants.URL_BACKEND + '/createNotes', { data: data }, { headers: headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/cxc.service.ts